import React from 'react';
import { formatGameTeamDetails } from './shared_helpers';
import { preserveQueryParams } from './browser_helpers';
import { env_url } from './endpoints';

export function formatTeamYardsInText(originalText = '') {
	const teamYardageTexts = originalText.match(/[a-zA-Z]+[0-9]+/gm) || [];
	if (!teamYardageTexts.length) {
		return originalText;
	}

	teamYardageTexts.forEach(teamYardage => {
		const teamTricode = (teamYardage.match(/[a-zA-Z]+/g)[0] || '').toUpperCase();
		const teamYards = teamYardage.match(/[0-9]+/g)[0] || '';
		originalText = originalText.replace(teamYardage, `${teamTricode} ${teamYards}`);
	});

	return originalText;
}

export function shortenPlayerNames(originalText, players = []) {
	let newText = originalText;

	if (!players.length) {
		return originalText;
	}

	for (const player of players) {
		const textToReplace = `${player.first_name} ${player.last_name}`;
		const playerInitial = player.first_name.charAt(0);
		const replacementText = `<b>${playerInitial}. ${player.last_name}</b>`;

		newText = newText.replace(textToReplace, replacementText);
	}
	return newText;
}

export function getPlayColor(play) {
	const darkBlue = 'darkBlue';
	const red = 'red';
	const grey = 'grey';
	const brightBlue = 'brightBlue';

	const playColorMap = new Map([
		['extra_point_attempt good', brightBlue],
		['two_point_attempt good', brightBlue],
		['extra_point_attempt no good', red],
		['field_goal no good', red],
		['two_point_attempt no good', red],
		['safety', red],
		// ['rush tackled', red],
		['two_minute_warning', grey],
		['period_end', grey],
		['timeout', grey],
		['tv_timeout', grey],
		['kick_off', grey],
		['kick_off_return', grey],
		['onside_kick_off', grey],
	]);

	return playColorMap.has(play.play_type) ? playColorMap.get(play.play_type) : darkBlue;
}

export function formatGamecardData(game = {}, options = {}) {
	const gameStatus = game.game_status;
	const {
		visitingTeamName,
		visitingTeamLogo,
		homeTeamName,
		homeTeamLogo,
		broadcastName,
		broadcastString,
		gameLoser,
		gameTime,
		gameDate,
	} = formatGameTeamDetails(game);

	const { league, type } = game;

	const matchupResult = game.series_matchups_result?.toUpperCase();

	let posessionTeam = 'hide';
	if (game.team_possession_id === game.visiting_team?.id) posessionTeam = 'visiting';
	if (game.team_possession_id === game.home_team?.id) posessionTeam = 'home';

	let currentVisitingLogo = visitingTeamLogo;
	let currentHomeLogo = homeTeamLogo;

	const commonProps = {
		visitingTeamName,
		visitingTeamLogo: currentVisitingLogo,
		homeTeamName,
		homeTeamLogo: currentHomeLogo,
		link: preserveQueryParams(`${game.new_game_url}`),
	};

	if (gameStatus === 'Pre-Game') {
		return {
			...commonProps,
			visitingTeamData: game.new_visiting_odds || '\u00A0',
			homeTeamData: game.new_home_odds || '\u00A0',
			teamDataStyle: 'odds',
			footerText: league === 'ncaafb' && !type.toLowerCase().includes('week') ? type : matchupResult,
			renderGameStatus: () => {
				return (
					<>
						{options.showDate ? (
							<div className='game_date'>
								{gameDate}, {gameTime}
							</div>
						) : (
							<div className='game_date'>{gameTime}</div>
						)}
						{broadcastName && <div className='broadcastName'>{broadcastName}</div>}
					</>
				);
			},
		};
	}
	if (gameStatus === 'In-Progress') {
		return {
			...commonProps,
			visitingTeamData: `${game.visiting_team?.score}`,
			homeTeamData: `${game.home_team?.score}`,
			footerText: league === 'ncaafb' && !type.toLowerCase().includes('week') ? type : broadcastString,
			posession: posessionTeam,
			renderGameStatus: () => {
				return (
					<>
						{game.new_status_long.split(' ').map((statusItem, index) => {
							return <div key={index}>{statusItem}</div>;
						})}
					</>
				);
			},
		};
	}
	if (gameStatus === 'Final') {
		return {
			...commonProps,
			visitingTeamData: `${game.visiting_team?.score}`,
			homeTeamData: `${game.home_team?.score}`,
			loser: gameLoser,
			footerText: league === 'ncaafb' && !type.toLowerCase().includes('week') ? type : matchupResult,
			renderGameStatus: () => <div>{game.new_status_long}</div>,
		};
	}

	// For games that are cancelled, postponed, forfeit, etc...
	return {
		...commonProps,
		visitingTeamData: '\u00A0',
		homeTeamData: '\u00A0',
		footerText: league === 'ncaafb' && !type.toLowerCase().includes('week') ? type : matchupResult,
		renderGameStatus: () => {
			return (
				<>
					<div>{gameStatus}</div>
				</>
			);
		},
	};
}
